/* ------------------------------------------
DEVICE IDNETIFY
--------------------------------------------*/

var deviceDiscover = function()
{
	// ----------------------------------------------

	// DOCUMENTAÇÃO DO PLUGIN:
	// http://hgoebl.github.io/mobile-detect.js/

	// ----------------------------------------------

	var md = new MobileDetect(window.navigator.userAgent);

	if(md.mobile() == null)
	{
		$('.btnAndroid, .btnIOs').css({'display':'none'});
		$('.btnDesktop').css({'display':'block'});
	}
	else
	{
		if(md.os() == 'iOS')
		{
			$('.btnAndroid, .btnDesktop').css({'display':'none'});
			$('.btnIOs').css({'display':'block'});
		}
		else if(md.os() == 'AndroidOS')
		{
			$('.btnIOs, .btnDesktop').css({'display':'none'});
			$('.btnAndroid').css({'display':'block'});
		}
		else
		{
			$('footer#mainFooter .blocos.app, #appBar .appButton').css({'display':'none'});
			$('#appBar ul').css({'width':'100%'});
		}
	}

	$('#appBar').stop().animate({opacity:1},300);
}

/* ------------------------------------------
IMAGE LAZY LOAD
--------------------------------------------*/

var imageLazyLoad = function(obj,imagem)
{
	if(!obj)
	{
		$('.imgLazyLoad').each(function()
		{
			if(!$(this).hasClass('responsiveImage'))
			{
				if($(this).find('.img').length > 0)
				{
					$(this).find('.img').css({'background-image':'url(&#39;'+$(this).data('img')+'&#39;)'});
				}
				else
				{
					$(this).prepend('<div class="img" style="background-image:url(&#39;'+$(this).data('img')+'&#39;)"></div>');
				}
			}
		});
	}
	else
	{

		if(obj.find('.img').length > 0)
		{
			obj.find('.img').css({'background-image':'url('+imagem+')'});
		}
		else
		{

			obj.prepend('<div class="img" style="background-image:url('+imagem+')"></div>');
		}
	}
}

/* ----------------------------------------------------------
DEFINE IMAGENS BACKGROUND DO BANNER RESPONSIVAS
-------------------------------------------------------------*/

var responsiveImages = function()
{
	function returnMedia(medidas)
	{
		// Apartir de 2025 podemos usar a media query de orientação, que é mais 
		// performática e fácil de implementar, para substituir a comparação entre largura e altura da janela.
		// if($(window).width() >= $(window).height())
		
		if (window.matchMedia('(orientation: landscape)').matches)
		{
			/* MEDIAS LANDSCAPES */

			if($(window).width() > 1366)
			{
				imageLazyLoad(medidas.boxImage,medidas.desktop_X);
			}

			if($(window).width() <= 1366 && $(window).width() >= 1024)
			{
				imageLazyLoad(medidas.boxImage,medidas.tablet_X);
			}

			if($(window).width() <= 1024)
			{
				imageLazyLoad(medidas.boxImage,medidas.mobile_X);
			}
		}
		

		else {

		/* PORTRAIT — SEM BREAKPOINT */
		imageLazyLoad(medidas.boxImage, medidas.portrait);

    	}

	}

	$('.responsiveImage').each(function()
	{
		returnMedia(
		{
			boxImage : $(this),
			desktop_X : $(this).attr('data-media-1920'),
			tablet_X : $(this).attr('data-media-1366'),
			mobile_X : $(this).attr('data-media-812'),
			// tablet_Y : $(this).attr('data-media-1024'),
			// mobile_Y : $(this).attr('data-media-609'),
			portrait:  $(this).attr('data-media-1024')
		});
	});
}

/* ----------------------------------------------------------
SCROLLTO
-------------------------------------------------------------*/

var buttonScrollTo = function()
{
	$('a.scrollTo').each(function()
	{
		$(this).on('click',function(e)
		{
			e.preventDefault();
			$('a.scrollTo').removeClass('activeScroll');
			$(this).addClass('activeScroll');
			$('html,body').stop().animate({ scrollTop : $($(this).attr('href')).offset().top - 170},1000);
		});
	});

	if($('main#lazer').length > 0 && window.location.hash)
	{
		var altura = $(window.location.hash).offset().top;

		$('html,body').stop().animate({ scrollTop : altura - 100},1000);
	}
}

/* ----------------------------------------------------------
INSTAGRAM
-------------------------------------------------------------*/

var instagramTool = function()
{
	if($('section#instagram'))
	{
		var phpPath = $('section#instagram').data('path')+'instashow/api/index.php';

		$('.my-instashow').eappsInstagramFeed({
	        api: phpPath,
	        source: $('section#instagram').data('profile'),
	        width: 'auto',
	        layout: 'slider',
	        gutter: 20,
	        columns: 6,
	        rows: 1,
	        sliderAutoplay: 4,
	        sliderSpeed: 1.5,
	        sliderArrows: true,
	        lang: 'pt-br',
	        responsive:{
		        560:{
		        	gutter: 5,
		            columns:2
		        },
		        740:{
		        	gutter: 10,
		            columns:4
		        },
		        1000:{
		            columns:5
		        }
		    }
	    });
	}
}

/* ----------------------------------------------------------
PÁGINAS COM ABAS E FORMULÁRIOS SOB DEMANDA
-------------------------------------------------------------*/

function formSeletor(type)
{
	if(type && type != '')
	{
		if(type == 'lojista')
		{
			$('form.seletorFormForm').removeClass('opened');
			$('#formComercializacaoLojista').addClass('opened');

			// console.log('ifLojista');
			// console.log(captchaComercializacaoLojista);
			// enviaFormulários
			// (
			// 	{
			// 		method 		: 'post',
			// 		formulario 	: 'formComercializacaoLojista',
			// 		recaptcha 	: captchaComercializacaoLojista
			// 	}
			// );
		}

		if(type == 'anunciar')
		{
			$('form.seletorFormForm').removeClass('opened');
			$('#formComercializacaoAnunciar').addClass('opened');
			// console.log('ifAnunciar');
			// console.log(captchaComercializacaoLojista);
			// enviaFormulários
			// (
			// 	{
			// 		method 		: 'post',
			// 		formulario 	: 'formComercializacaoAnunciar',
			// 		recaptcha 	: captchaComercializacaoAnunciar
			// 	}
			// );
		}

		// if(type == 'newsletter')
		// {
			// enviaFormulários
			// (
			// 	{
			// 		method 		: 'post',
			// 		formulario 	: 'formNewsletter',
			// 		recaptcha 	: captchaFormNewsletter
			// 	}
			// );
		// }

		// if(type == 'contato')
		// {
			// enviaFormulários
			// (
			// 	{
			// 		method 		: 'post',
			// 		formulario 	: 'formContato',
			// 		recaptcha 	: captchaFormContato
			// 	}
			// );
		// }
	}
}

var TabContentsController = function()
{
	if( $('main.cinema').length > 0 )
	{
		var hashOrigin 	= window.location.hash.split('/');
		var urlHash 	= hashOrigin[0].replace('#','');
		var thehAncor 	= hashOrigin[1];
	}
	else
	{
		var hashOrigin = window.location.hash.replace('#','').split('-');
		var urlHash = hashOrigin[0];
	}

	var faleConosco = $('.tabContentSection'),
		tabNav 		= faleConosco.find('.tabNav'),
		tabContent 	= faleConosco.find('.tabContent');

	/* FUNÇÕES */

	function swipeCinema()
	{
		var cinemaOWL = $('main.cinema .owl-carousel').owlCarousel(
		{
			autoWidth: true,
			margin:15,
			items:7,
			center:false,
			loop: false,
		    nav: false,
		    mouseDrag: true,
			touchDrag: true,
			navSpeed: 1000,
			onInitialized  : callbackCinemaSections,
			responsive:{
		        0:{
		            items:4,
		            margin:10,
		        },
		        568:{
		        	margin:10,
		            items:7,
		        },
		        740:{
		            margin:10,
		        },
		        1180:{
					margin:15,
		            items:7,
		        }
		    }
		});

		function callbackCinemaSections()
		{
			$('#pageInternas.cinema .owl-carousel').stop().animate({opacity: 1},400);

			if(window.location.hash)
			{
				const itemList = $('#pageInternas.cinema .owl-carousel li.item');
				const hash = window.location.hash;

				itemList.removeClass('current-content').each(function()
				{
					const item = $(this);
					const tabItem = item.find('a');

					if(tabItem.attr('href') == hash)
						item.addClass('current-content');
				});
			}
		}
	}

	function swiperFaleConosco()
	{
		const $carousel = $('.tabsContatosLazer .tabNav.owl-carousel');

		if (window.innerWidth <= 767)
		{
			if (!$carousel.hasClass('owl-loaded'))
			{
				$carousel.owlCarousel({
					margin: 10,
					items: 1,
					loop: false,
					nav: true,
					mouseDrag: true,
					touchDrag: true,
					navSpeed: 600,
					autoWidth: true,
				});
			}
		} 
		else
		{
			if ($carousel.hasClass('owl-loaded')) {
				$carousel.trigger('destroy.owl.carousel');
				$carousel.find('.owl-stage-outer').children().unwrap(); // limpa marcações internas
				$carousel.removeClass('owl-loaded');
				$carousel.removeAttr('style');
			}
		}
	}	

	function callBackFunctions()
	{
		$('#formContato').submit(function(e)
		{
			e.preventDefault();
		});
	}

	function accordeon()
	{
		$('.accordeon dt').click(function()
		{
			$(this).toggleClass('opened');
		});
	}

	function openCurrentTabContent(hash)
	{
		if(hash && hash != '')
		{
			tabContent.find('#'+hash).css({'display':'block'}).stop().animate({opacity:1},300);

			if( hashOrigin[1] && hashOrigin[1] != '' )
			{
				formSeletor(hashOrigin[1])
			}

			if( thehAncor && thehAncor != '' )
			{
				var altura = tabContent.find('#'+hash).find('li[data-movie="'+thehAncor+'"]').offset().top;

				$('html,body').stop().animate({ scrollTop : altura - 70},1000);
			}
		}
		else
		{
			tabContent.find('.tab:first-child').css({'display':'block'}).stop().animate({opacity:1},300);
		}
	}

	function resetTabContent(hash)
	{
		tabContent.find('.tab').stop().animate({opacity:0},200,function()
		{
			$(this).css({'display':'none'});
		});

		if(hash && hash != '')
		{
			openCurrentTabContent(hash);
		}
		else if(urlHash && urlHash != '')
		{
			openCurrentTabContent(urlHash);
		}
		else
		{
			openCurrentTabContent();
		}
	}

	function setCurrentTabNav()
	{
		//tabNav.find('li').removeClass('current-content');

		if(urlHash && urlHash != '')
		{
			tabNav.find('li a').each(function(e)
			{
				$(this).click(function(e) { e.preventDefault(); })

				if($(this).attr('href').replace('#','') == urlHash)
				{
					$(this).parent('li').addClass('current-content');
				}
			});
		}
		else
		{
			tabNav.find('li:first-child').addClass('current-content');
		}

		if(tabNav.hasClass('owl-carousel'))
		{
			swipeCinema();
			swiperFaleConosco();
		}

		resetTabContent();
	}

	/* START FUNÇÔES */

	accordeon();
	setCurrentTabNav();

	/* RESIZES */

	window.addEventListener('resize', function()
	{
		if(tabNav.hasClass('owl-carousel'))
		{
			swiperFaleConosco();
		}
	});

	/* START EVENTOS */

	tabNav.find('li.deactivated a').on('click',function()
	{
		return false;
	});


	tabNav.find('li:not(.deactivated) a').on('click',function(e)
	{
		e.preventDefault();
		resetTabContent($(this).attr('href').replace('#',''));
		history.pushState(null, null, $(this).attr('href') );
		tabNav.find('li').removeClass('current-content');
		$(this).parent('li').addClass('current-content');
	});

	if(urlHash == 'comercializacao')
	{
		if(window.location.hash.replace('#','').split('-')[1])
		{
			$('.seletorForm div.select select option').each(function()
			{
				if( window.location.hash.replace('#','').split('-')[1] == 'lojista' && $(this).attr('value') == '#formComercializacaoLojista' )
				{
					$(this).attr('selected','selected');
				}
				if( window.location.hash.replace('#','').split('-')[1] == 'anunciar' && $(this).attr('value') == '#formComercializacaoAnunciar' )
				{
					$(this).attr('selected','selected');
				}
			});
		}
	}

	$('.seletorForm div.select select').on('change',function()
	{

		$('form.seletorFormForm').find('.alertsMessages').stop().animate({height : 0, opacity : 0},300);

		$('form.seletorFormForm').removeClass('opened').find('input[type="reset"]').trigger('click');

		if( $(this).val() == '#formComercializacaoLojista' )
		{
			formSeletor('lojista');
			console.log('form lojista', formSeletor('lojista'))
			window.location.hash = 'comercializacao-lojista';


		}
		else if( $(this).val() == '#formComercializacaoAnunciar' )
		{
			formSeletor('anunciar');
			window.location.hash = 'comercializacao-anunciar';
		}
		else
		{
			window.location.hash = 'comercializacao';
		}

	});
}

/* ----------------------------------------------------------
SELECT PÁGINA LOGISTA
-------------------------------------------------------------*/

var seletctLojista = $('.seletorFormLojista form.seletorFormForm');

setTimeout(() => {
	$(seletctLojista.prevObject[0].forms).removeClass('opened');
}, 1000);

$('.seletorFormLojista div.select select').on('change',function()
	{
		$('form.seletorFormLojista').find('.alertsMessages').stop().animate({height : 0, opacity : 0},300);
		$('form.seletorFormLojista').removeClass('opened').find('input[type="reset"]').trigger('click');
		if( $(this).val() == '#formComercializacaoLojista' )
		{

			$('form.seletorFormForm').removeClass('opened');
			$('#formComercializacaoLojista').addClass('opened');

		}
		else if( $(this).val() == '#formComercializacaoAnunciar' )
		{

			$('form.seletorFormForm').removeClass('opened');
			$('#formComercializacaoAnunciar').addClass('opened');


		}
		else
		{
			$('form.seletorFormForm').removeClass('opened');
		}

});



/* ----------------------------------------------------------
LINKS RELACIONADOS
-------------------------------------------------------------*/

var linkRelacionados = function()
{
	$('#relacionados.lojas li.item').each(function()
	{
		var href = $(this).find('.imgLazyLoad a').attr('href');

		$(this).find('.legenda').css({'cursor':'pointer'}).on('click',function()
		{
			window.location.href = href;
		});
	});
}

/* ----------------------------------------------------------
CAROUSEL OUTROS SHOPPINS - COMERCIALIZAÇÃO E MÍDIA
-------------------------------------------------------------*/
var carouselOutrosShoppings = function(){
	$('section#outrosShoppings .owl-carousel').owlCarousel({
		loop:true,
		margin:10,
		nav:true,
		dots:false,
		responsive:{
			0:{
				items:1
			},
			600:{
				items:2
			},
			1000:{
				items:3
			},
			1300:{
				items:4
			}
		}
	})
}

/* ----------------------------------------------------------
INICIA SCRIPTS
-------------------------------------------------------------*/

jQuery(function()
{
	$ = jQuery;

	topBarScroll();
	deviceDiscover();
	TabContentsController();

	var swiper 		= new sliders();
	var climaTempo 	= new weather();
	var barraTopo 	= new ControlesTopBar();
	var filtros 	= new initFiltrosLojas();

	Header();

	$('.tel-mask').mask('(00) 0000-00009');
	$('.cel-mask').mask('00000-0009');
	$('.cnpj-mask').mask('00.000.000/0000-00');
	$('.cep-mask').mask('00000-000');
	$('.cpf-mask').mask('00000000009');
	$('.date-mask').mask('00/00/0000');
	$('.rg-mask').mask('0000000009');

	$(window).resize(function()
	{
		deviceDiscover();
		responsiveImages();
		swiper;
		instagramTool();
	});

	window.onload = function()
	{
		imageLazyLoad();
		responsiveImages();
		buttonScrollTo();
		instagramTool();
		//formSeletor();
		linkRelacionados();
		swiper
		var googleMaps 		= new gMaps();
		var clubeempresa 	= new ClubeEmpresa();
		var cookiePolicy 	= new CookiePolicy();

		if( $('article.lojista').length > 0 )
		{
			formSeletor('lojista');
			formSeletor('anunciar');
		}

		if( $('section#outrosShoppings').length > 0 ){
			carouselOutrosShoppings();
		}
	}();

	document.addEventListener('keydown',function(e)
	{
		if (e.key === 'Tab') {
			$('body').addClass('tabKey');
			$('.overContent').css({'display' : 'none'});
			$('.filmeTitle').css({'display' : 'block'});
		}
	});

	$(".nClose").click(function()
	{
        document.cookie = "aceptCookie=True";
        $( ".cTB" ).fadeOut( "slow" );
    });

	const optionValue = $('.formularioStyle div.select select#goToShopping option').get(0);
	setTimeout(() => {
		$(optionValue).val('/');
		// $(optionValue).unbind('click');
	}, 2000);

    $('.formularioStyle div.select select#goToShopping').on('change',function()
    {
		const linkValue = $(this).val();
		if(linkValue === '/'){
			window.open($(this).val(), '_self');
		}
		else{
			window.open($(this).val(), '_blank');
		}
    	//$('form#changeShopping').attr( 'action', $(this).val()+"?origem=seletor-footer" ).submit();
	})

	// TABS
	$( "#tabs" ).tabs({
		collapsible: true,
		active: false,
		//active: false,
		show: { effect: "fade", duration: 800 }
	});

	//
	// ATENDIMENTO VIRTUAL
	//
	var target = $('#atendenteVirtual .txt'),
	msg = target.find('.msg'),
	typing = target.find('.typing'),
	timeMSG = 5000,
	timeTyping = 2000;

	// Verifica se possui mais de uma frase para entrar no loop
	if(msg.length > 1){
		setTimeout(function(){
			loopMsg();
			setInterval(function () {
				loopMsg();
			}, timeMSG+timeTyping);
		}, timeTyping)
	} else {
		setTimeout(function(){
			typing.hide();
			msg.addClass('active');
		}, timeTyping)
	}

	// Passando frases
	function loopMsg(){
		typing.hide();
		target.removeClass('resize');
		msg.each(function( i, e ) {
			//if($(this).hasClass('active')){
				msg.removeClass('active');
			//}
			if($(this).hasClass('next')){
				$(this).addClass('active');
				$(this).removeClass('next');

				if($(this).next().hasClass('msg')){
					$(this).next().addClass('next');
				} else {
					msg.first().addClass('next');
				}
				return false;
			}
		});
		setTimeout(function(){
			typing.show();
			target.addClass('resize');
			msg.removeClass('active');
		}, timeMSG)
	}

	// Digitando
	setInterval(function () {
		target.find('.typing').removeClass('top');
	}, 300);

	setInterval(function () {
		target.find('.typing.first').addClass('top');
	}, 1200);

	setTimeout(function(){
	  setInterval(function () {
		target.find('.typing.middle').addClass('top');
	  }, 600);
	}, 300)

	setTimeout(function(){
	  setInterval(function () {
		target.find('.typing.last').addClass('top');
		}, 1200);
	}, 600)
});

/* ----------------------------------------------------------
NOVA FUNÇÃO ACORDEÃO
-------------------------------------------------------------*/

// Adiciona eventos para o acordeão
$('#accordionTeatro').on({
    'hidden.bs.collapse': function (event) {
        console.log('Collapse hidden:', event.target.id);
    },
    'shown.bs.collapse': function (event) {
        console.log('Collapse shown:', event.target.id);
    }
});


jQuery(document).ready(function($) {
    deviceDiscover();
});